import styled from "styled-components";

export const HeaderOptionsSection = styled.section`

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;

  padding: 1rem 0;

  > div {
    display: flex;
    gap: 1rem;
  }

  user-select: none;

`;

export const DownloadUploadOptions = styled.div`

  display: flex;
  gap: 1rem;
  padding-right: 2rem;
  cursor: pointer;

`;

export const SelectAllButton = styled.div`

  display: flex;
  align-items: center;
  gap: 0.5rem;

  padding: 0.6rem 1rem;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 10px;

  cursor: pointer;


  &:hover {
    background-color: rgba(0, 0, 0, 0.03);
  }

  > input[type="checkbox"] {
    width: 1rem;
    height: 1rem;

    border: 1px solid #ccc;
    border-radius: 3px;
    cursor: pointer;
    appearance: none;
    display: grid;
    place-content: center;

    background-color: #EDEDED;

    &:checked {
      background-color: #E33AA9;
      border-color: #E33AA9;
    }

    &::after {
      position: relative;
      top: -1px;
      content: "";
      width: 5px;
      height: 10px;
      border-right: 2px solid white;
      border-bottom: 2px solid white;
      transform: rotate(45deg) scale(0);
      transition: transform 0.1s ease-in-out;
    }

    &:checked::after {
      transform: rotate(45deg) scale(1);
    }
  }

  > p {
    user-select: none;
    color: #000;
    font-size: 13px;
    letter-spacing: -0.25px;
  }


`;